/*
 * @Author: songyzh
 * @Date: 2020-08-19 10:11:21
 * @LastEditors: songyzh
 * @LastEditTime: 2020-08-19 10:17:48
 */
import { JGET } from './base';

export function getAppConfig() {
  return JGET('static/app-config.json', '获取系统配置文件');
}

export default {};
